import {
  DOWNLOAD_VENDOR_DTEAILS_DATA,
  DOWNLOAD_VENDOR_LDC_DATA,
  SEARCH_FILTER_VENDOR,
  SEARCH_FILTER_VENDOR_LDC,
  DELETE_VENDOR_MASTER,
  EDIT_VENDOR_DETAILS,
  EDIT_VENDOR_LDC_DETAILS,
  DELETE_VENDOR_LDC_API,
} from '../endpoints/apiEndpoints'
import {
  buildRequestHeader,
  handleErrorResponse,
  handleRequestFailure,
  handleSuccessResponse,
  urlBuilder,
} from './apiUtils'

export const searchFilterVendor = async (payload, tanUuid) => {
  const url = urlBuilder(SEARCH_FILTER_VENDOR, { tanUuid })
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadVendorDetailsData = async (payload,tanUuid) => {
  const url = urlBuilder(DOWNLOAD_VENDOR_DTEAILS_DATA,{tanUuid})
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const searchFilterVendorLDC = async (payload, tanUuid) => {
  const url = urlBuilder(SEARCH_FILTER_VENDOR_LDC, { tanUuid })
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const downloadVendorLDCData = async (payload, tanUuid) => {
  const url = urlBuilder(DOWNLOAD_VENDOR_LDC_DATA, { tanUuid })
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const deleteVendorMaster = async (payload) => {
  const url = urlBuilder(DELETE_VENDOR_MASTER)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const deleteVendorLDC = async (payload) => {
  const url = urlBuilder(DELETE_VENDOR_LDC_API)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const updateVendorMaster = async(payload) => {
  const url = urlBuilder(EDIT_VENDOR_DETAILS)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}

export const updateVendorLDC = async(payload) => {
  const url = urlBuilder(EDIT_VENDOR_LDC_DETAILS)
  const requestHeader = buildRequestHeader('POST', payload)
  try {
    const response = await fetch(url, requestHeader)
    if (!response.ok) return await handleRequestFailure(response)
    else return await handleSuccessResponse(response)
  } catch (error) {
    return handleErrorResponse(error)
  }
}